export class SurgeryProcedureType {
    id = null;
    name = null;
    code = null;
    description = null;
}